import { createContext } from 'react'

export type Sizes = { horizontal?: 'wide' }

interface PopupSizeContextProps {
  sizes: Sizes
  setSizes: (sizes: Sizes) => void
}

export const PopupSizeContext = createContext<PopupSizeContextProps>({
  sizes: {},
  setSizes: () => {},
})

PopupSizeContext.displayName = 'PopupSizeContext'
